import { RequestTagType } from 'modules/request'
import {
  DocumentsContainer,
  DocumentsList,
  useProjectUuid,
  useDrawdownsTabs,
  useAMLTabs,
  useDocumentsFilter,
  useGetDocuments,
  DOCUMENTS_COLLECTION,
} from '..'

interface DocumentsProposalProps {
  isRequest?: boolean
  tag?: RequestTagType
}

export default function DocumentsOthers({isRequest, tag}: DocumentsProposalProps) {
  const projectUuid = useProjectUuid(isRequest, tag)
  const {data: documents} = useGetDocuments(projectUuid)
  const {filteredDocuments, search, sort, setSearch, setSort} =
    useDocumentsFilter(documents, DOCUMENTS_COLLECTION.others.key)
  const {drawdownsTabs} = useDrawdownsTabs(documents, isRequest)
  const {amlTabs} = useAMLTabs(projectUuid)

  const documentsCount = documents.filter(
    (document) => document.collection === 'others' && !document.archived
  ).length

  return (
    <DocumentsContainer
      categoryKey="others"
      documentsCount={documentsCount}
      modelUuid={projectUuid}
      modelType="project"
      search={search}
      sort={sort}
      setSearch={setSearch}
      setSort={setSort}
    >
      <DocumentsList
        columns={4}
        projectUuid={projectUuid}
        modelUuid={projectUuid}
        modelType="project"
        collection={DOCUMENTS_COLLECTION.others.key}
        search={search}
        documents={filteredDocuments}
        drawdownsTabs={drawdownsTabs}
        amlTabs={amlTabs}
      />
    </DocumentsContainer>
  )
}
